import { Component, Mixins } from 'vue-property-decorator';
import { MagicConfigMixin } from '@gig/magic-common';

import { isUpdatedTermsPromptHidden } from '../../services';

@Component({
    name: 'terms-updated-manager',
})
export default class TermsUpdatedManagerComponent extends Mixins(
    MagicConfigMixin,
) {
    get isUpdatedTermsPromptHidden() {
        return isUpdatedTermsPromptHidden(this.$route);
    }
}
